// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3444":"fe24eebd","5827":"8efd3605"}[chunkId] + ".chunk.css";
};